import { render } from "./EmailHistory.vue?vue&type=template&id=250ab107&ts=true"
import script from "./EmailHistory.vue?vue&type=script&lang=ts"
export * from "./EmailHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/Media/WebDevelop/enfint-email/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__